import {
  FETCH_PAYMENT,
  FETCH_PAYMENT_SUCCESS,
  FETCH_PAYMENT_FAILED
} from '../../types';

const initialState = {
  payment: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchPaymentReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_PAYMENT:
      return {
        ...state,
        isLoading: true,
          payment: action.payload
      }
      case FETCH_PAYMENT_SUCCESS:
        return {
          ...state,
          isLoading: false,
            payment: action.payload
        }
        case FETCH_PAYMENT_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchPaymentReducer;
